// extracted by mini-css-extract-plugin
export var content = "_nz-1";
export var fullScreen = "_nz-0";